export const onServiceWorkerUpdateFound = () => {
  console.log(
    `This application has been updated. Reload to display the latest version`
  )
}
